import type { ImportVoucherRow, VoucherCandidate } from '@/marketing/models/voucher';

export interface ParsedVoucherUserIds {
  userIds: number[];
  invalidEntries: string[];
}

/** Accepts the WP user IDs an admin pastes in, separated by commas, spaces or newlines. */
export function parseVoucherUserIds(raw: string): ParsedVoucherUserIds {
  const entries = raw.split(/[\s,]+/).filter((entry) => entry.length > 0);
  const userIds: number[] = [];
  const invalidEntries: string[] = [];

  for (const entry of entries) {
    const userId = Number(entry);
    if (!Number.isInteger(userId) || userId < 1) {
      invalidEntries.push(entry);
      continue;
    }
    if (!userIds.includes(userId)) {
      userIds.push(userId);
    }
  }

  return { userIds, invalidEntries };
}

export interface BuildImportRowsParams {
  candidates: VoucherCandidate[];
  commissionPercent: number;
}

/**
 * Creators picked by handle go through the import route: it resolves the Creator Hub account by
 * handle itself and keeps the code unclaimed when there is none, which handle-picked targets need.
 */
export function buildImportRowsFromCandidates({
  candidates,
  commissionPercent,
}: BuildImportRowsParams): ImportVoucherRow[] {
  return candidates.map((candidate) => ({
    handle: candidate.handle,
    platform: candidate.platform,
    commissionPercent,
  }));
}
